import { render } from "./admin.vue?vue&type=template&id=1fdfb1c7"
import script from "./admin.vue?vue&type=script&lang=js"
export * from "./admin.vue?vue&type=script&lang=js"

import "./admin.vue?vue&type=style&index=0&id=1fdfb1c7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__